<template>
  <div />
</template>

<script>

/**
 * Vue: Size guide (size-guide)
 * -----------------------------------------------------------------------------
 * Sizing content with an optional table, sourced from page content.
 *
 * @param {String} sectionId - Section's Liquid ID.
 *
 */
import classes from '~/config/classes'

export default {
  name: 'SizeGuide',

  props: {
    sectionId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      selectors: {},
    }
  },

  mounted() {
    this.setSelectors()
    this.setEventListeners()
    this.setDefaultState()
  },

  methods: {

    /**
     * Sets the node selectors.
     */
    setSelectors() {
      const container = document.querySelector(
        `#vue-element [js-size-guide="${this.sectionId}"]`,
      )

      this.selectors = {
        container,
        button: container.querySelectorAll('[js-size-guide="button"]'),
        page: container.querySelectorAll('[js-size-guide="page"]'),
        state: container.querySelector('[js-size-guide="state"]'),
      }
    },

    /**
     * Sets and handles the event listeners.
     */
    setEventListeners() {
      this.selectors.button.forEach((button) => {
        button.addEventListener('click', this.handleButtonEvent)
      })

      cnvs.EventBus.listen('cnvs:resize', () => {
        this.setDefaultState()
      })
    },

    /**
     * Handles the button click event.
     * @param {Object} event - The event object.
     * @param {HTMLElement} event.target - The target element.
     */
    handleButtonEvent({ target }) {
      const page = target.getAttribute('aria-controls')

      if (!page) {
        return
      }

      this.setActivePage(page)
      this.setActiveControl(page)
    },

    /**
     * Sets the active page item.
     * @param {String} id - The page identifier.
     */
    setActivePage(id) {
      this.selectors.page.forEach((page) => {
        if (page.id === id) {
          page.classList.add(classes.active)
          return
        }

        page.classList.remove(classes.active)
      })
    },

    /**
     * Sets the active control item.
     * @param {String} id - The page identifier.
     */
    setActiveControl(id) {
      this.selectors.button.forEach((button) => {
        const controls = button.getAttribute('aria-controls')

        if (controls === id) {
          button.classList.add(classes.active)
          this.positionStateByElement(button)
          return
        }

        button.classList.remove(classes.active)
      })
    },

    /**
     * Returns the active control element.
     * @returns {HTMLElement}
     */
    getActiveControlElement() {
      return Array.from(this.selectors.button).find(
        (element) => element.classList.contains(classes.active),
      )
    },

    /**
     * Positions the state by the given element.
     * @param {HTMLElement} element - The element to position by.
     */
    positionStateByElement(element) {
      if (!this.selectors.state || !element) {
        return
      }

      this.selectors.state.style.width = `${element.offsetWidth}px`
      this.selectors.state.style.left = `${element.offsetLeft}px`
    },

    /**
     * Sets the default state.
     */
    setDefaultState() {
      const control = this.getActiveControlElement()

      if (!this.selectors.state || !control) {
        return
      }

      this.positionStateByElement(control)
    },
  },
}
</script>

<style lang="scss">
@import './size-guide';
</style>
